export default [
    {
        path: 'relatorios',
        component: require('./Read').default,
        meta: { middleware: 'auth', controller: 'RelatorioController' }
    },
    {
        path: 'relatorio/add',
        component: require('./Add').default,
        meta: { middleware: 'auth', controller: 'RelatorioController' },
    },
    {
        path: 'relatorio/edit/:id',
        component: require('./Edit').default,
        meta: { middleware: 'auth', controller: 'RelatorioController' },
    },
    {
        path: 'relatorio/show/:id',
        component: require('./Show').default,
        meta: {
            middleware: 'auth',
            controller: 'RelatorioController'
        }
    },
    {
        path: 'relatorio/RMA',
        component: require('./RMA').default,
        meta: {
            middleware: 'auth',
            controller: 'RelatorioController'
        }
    },
    {
        path: 'relatorio/RMA/historico',
        component: require('./HistoricoRelatorios').default,
        meta: {
            middleware: 'auth',
            controller: 'RelatorioController'
        }
    },
    {
        path: 'relatorios/gestor',
        component: require('./Gestor').default,
        meta: {
            middleware: 'auth',
            controller: 'RelatorioController'
        }
    },
    {
        path: 'relatorios/painel/gestor',
        component: require('./gestor/Home').default,
        redirect: '/dashboard/relatorios/painel/gestor/atendimentos',
        meta: { middleware: 'auth', controller: 'PainelGestorController' },
        children: [
            {
                path: 'atendimentos',
                component: require('./gestor/modules/Atendimento').default,
                meta: { middleware: 'auth', controller: 'PainelGestorController' }
            },
        ]
    },
    {
        path: 'relatorios/suasfacil',
        component: require('./suasfacil/Home').default,
        meta: {
            middleware: 'auth',
            controller: 'RelatorioController'
        }
    },

];


